const authRoles = {
  SuperAdmin: ['TmcSupport'],
  UserAdmins: ['UserAdministration'],
  TmcRestoreDb: ['TmcRestoreDatabase'],
  AuditUsers: ['AuditUser'],
  AuditLogAdmins: ['AuditLogAdministration'],
  SettingsUsers: ['SettingsUser'],
  BankProfileAdmins: ['BankProfileAdministration'],
  ImportExportAdmins: ['ImportExportAdministration'],
  TaxAdmin: ['TaxAdministration'],
  CommonUsers: ['CommonUser'],
  SharedListAdmins: ['SharedListAdministration'],
  UnregisteredDepositUser: ['UnregisteredDepositUser'],
  PaymentAdmin: ['PaymentsAdministration'],
  WarEdit: [
    'WarAdministration',
    'WarUser',
  ],
  WarRead: [
    'WarAdministration',
    'WarUser',
    'ReadOnly',
  ],
  OD: [
    'ODAdministration',
    'ODUser',
  ],
  ODRead: [
    'ODAdministration',
    'ODUser',
    'ReadOnly',
    'UnregisteredDepositUser',
  ],
  MiscAuth: [
    'MiscAdministration',
    'MiscUser',
  ],
  MiscRead: [
    'MiscAdministration',
    'MiscUser',
    'ReadOnly',
  ],
  MtgAuth: [
    'MtgAdministration',
    'MtgUser',
  ],
  MtgRead: [
    'MtgAdministration',
    'MtgUser',
    'ReadOnly',
  ],
  GlAuth: [
    'GLAdministration',
    'GLUser',
  ],
  GlRead: [
    'GLAdministration',
    'GLUser',
    'ReadOnly',
  ],
  TaxAuth: [
    'TaxAdministration',
    'TaxUser',
  ],
  TaxRead: [
    'TaxAdministration',
    'TaxUser',
    'ReadOnly',
  ],
  PaymentsAuth: [
    'PaymentsAdministration',
    'PaymentsUser',
  ],
  AjustmentAuth: [
    'AjustmentAdministration',
    'AdjustmentUser',
  ],
  MortgageCoAdmin: ['MortgageCoAdministration'],
  MortgageCoAuth: [
    'MortgageCoAdministration',
    'MortgageCoUser',
  ],
  DelinquentTaxAuth: [
    'DelinquentTaxAdministration',
    'DelinquentTaxUser',
  ],
  SpecialTaxAuth: [
    'SpecialTaxAdministration',
    'SpecialTaxUser',
  ],
  ApportionmentAuth: [
    'ApportionmentAdministration',
    'ApportionmentUser',
  ],
};

authRoles.shared = {
  BankAuth: [
    ...authRoles.WarEdit,
    ...authRoles.OD,
    ...authRoles.MiscAuth,
    ...authRoles.MtgAuth,
    ...authRoles.GlAuth,
    ...authRoles.TaxAuth,
  ],
  SharedProgram: [
    ...authRoles.WarRead,
    ...authRoles.ODRead,
    ...authRoles.MiscRead,
    ...authRoles.MtgRead,
    ...authRoles.GlRead,
    ...authRoles.TaxRead,
    ...authRoles.SharedListAdmins,
    ...authRoles.SuperAdmin,
  ],
  SharedListAdmin: [
    ...authRoles.SharedListAdmins,
    ...authRoles.SuperAdmin,
  ],
  BankRead: [
    ...authRoles.WarRead,
    ...authRoles.ODRead,
    ...authRoles.MiscRead,
    ...authRoles.MtgRead,
    ...authRoles.GlRead,
    ...authRoles.TaxRead,
  ],
};

export { authRoles };

export default { authRoles };
